import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject} from 'rxjs';
import { ManagerReviewerFeedbackModalComponent } from './manager/mgr-reviewer-feedback-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BackendService } from './common/services/backend.service';

declare var window:any;

@Injectable()
export class SharedReviewerService {

    private _feedback: Subject<object> = new Subject();
    public modal: any;
    public fbByReviewer: any;

    constructor(
        private _backendService: BackendService,
        private _route: Router,
        private modalService: NgbModal
    ) {}

    get feedback() {
        return this._feedback.asObservable();
    }

    getFeedback(id, param, data, external:boolean = false) {
        this._backendService.getAll(param, 'video-interview-attempt/' + id).subscribe((resp) => {
            if (resp) {
               this._feedback.next([data]);
            }
        });
    }

    saveFeedback(id:any, data:any, external:boolean = false) {
        let params = this.getFeedbackParams(external);
        return this._backendService.createFeedback('video-interview-attempt/' + id + params, data)
            .subscribe((fb) => {
                this.getFeedback(id, params, data, external);
        });
    }

    getFeedbackParams(external) {
        let params = '/feedback';
        if (external) {
            params = params + '?t=' + window.parent.REVIEWER_TOKEN;
        }
        return params;
    }

    sendFeedbackNotification(id, external:boolean = false) {
        let param = 'send-feedback';
        if (external) {
            param = param + '?t=' + window.parent.REVIEWER_TOKEN;
        }
        this._backendService.sendFeedbackNotification(id, 'video-interview-attempt', param)
            .subscribe((resp) => {
                if (resp) {
                    this.endFeedback(id);
                }
            });
    }

    openReviewerModal(id, interview, reviewer = '', external:boolean = false) {
        this.modal = this.modalService.open(ManagerReviewerFeedbackModalComponent, {
            container: '.interviews-modal-container',
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        this.modal.componentInstance.id = id
        this.modal.componentInstance.currentReviewer = reviewer;
        this.modal.componentInstance.interview = interview;
        this.modal.componentInstance.external = external;
        return this.modal;
    }
    endFeedback(id) {
        this._route.navigateByUrl('/mock-interviews/' + id + '/end');
        if (window.parent.REVIEWER_TOKEN) {
            return;
        }
        setTimeout(() => {
            window.parent.location.href = '/manager/index.php?mode=list';
        }, 1000);
    }
}

